(function () {
  function initSizePillsObserver() {
    const cards = document.querySelectorAll("product-card[data-product-card], [data-product-card]");

    // Only on mobile
    const isMobile = window.matchMedia("(max-width: 767px)").matches;

    // אם לא מובייל - ננקה סטייט ונצא
    if (!isMobile) {
      cards.forEach((c) => {
        c.classList.remove("is-inview");
        c.classList.remove("lb-sizes-expanded");
      });
      if (window.__lbSizePillsIO) window.__lbSizePillsIO.disconnect();
      return;
    }

    // Fallback: אם אין IntersectionObserver פשוט תראה הכל
    if (!("IntersectionObserver" in window)) {
      cards.forEach((c) => c.classList.add("is-inview"));
      return;
    }

    // Disconnect previous observer if exists
    if (window.__lbSizePillsIO) window.__lbSizePillsIO.disconnect();

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // מופיע פעם אחת ונשאר
            entry.target.classList.add("is-inview");
            // מפסיקים לעקוב אחרי הכרטיס הזה
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.35 }
    );

    cards.forEach((card) => {
      if (!card.classList.contains("is-inview")) io.observe(card);
    });

    window.__lbSizePillsIO = io;
  }

  // לחיצה על החץ: הרחבה/כיווץ בלי לעבור לעמוד מוצר
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".lb-size-more");
    if (!btn) {
      // אם לחצו מחוץ ל-overlay – נסגור הכל (נעים במובייל)
      const isMobile = window.matchMedia("(max-width: 767px)").matches;
      if (!isMobile) return;
      document.querySelectorAll(".lb-sizes-expanded").forEach((c) => c.classList.remove("lb-sizes-expanded"));
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    const card = btn.closest("product-card[data-product-card]") || btn.closest("[data-product-card]");
    if (!card) return;

    // סוגרים כרטיסים אחרים כדי שלא יהיו כמה פתוחים
    document.querySelectorAll(".lb-sizes-expanded").forEach((c) => {
      if (c !== card) c.classList.remove("lb-sizes-expanded");
    });

    card.classList.toggle("lb-sizes-expanded");
  });

  document.addEventListener("DOMContentLoaded", initSizePillsObserver);

  // חשוב במאק/ספארי: לפעמים חוזרים לעמוד דרך cache
  window.addEventListener("pageshow", initSizePillsObserver);

  window.addEventListener("resize", () => {
    clearTimeout(window.__lbSizePillsResizeT);
    window.__lbSizePillsResizeT = setTimeout(initSizePillsObserver, 150);
  });

  // לחשיפה מחדש אם יש אינפיניטי/טעינה דינמית
  window.lbInitSizePills = initSizePillsObserver;
})();
